// Filtra desconsiderando maiúsculas, minúsculas e espaços
const filterString = (value, query) => value.trim().match(new RegExp(query.trim(), 'i'))

// Filtra aplicando o devido template de cada coluna
const filterByBank = (row, query) => filterString(row.banco.codigo + '-' + row.banco.nomeFantasia, query)
const filterByAgency = (row, query) => filterString(row.numAgencia + (row.digAgencia ? '-' + row.digAgencia : ''), query)
const filterByAccount = (row, query) => filterString(row.conta + (row.digConta ? '-' + row.digConta : ''), query)
const filterByAccessProfileName = (row, query) => {
  if (row.perfilAcesso) {
    if (row.perfilAcesso.nomePerfilAcesso) {
      return filterString(row.perfilAcesso ? row.perfilAcesso.nomePerfilAcesso : '-', query)
    } else if (row.perfilAcesso.nome) {
      return filterString(row.perfilAcesso ? row.perfilAcesso.nome : '-', query)
    }
  } else if (row.nomePerfilAcesso) {
    return filterString(row.nomePerfilAcesso ? row.nomePerfilAcesso : '-', query)
  } else if (row.nome) {
    return filterString(row.nome ? row.nome : '-', query)
  }
}
const filterBySituation = (row, query) => filterString(row.ativo ? 'Ativo' : 'Inativo', query)
const filterByCategory = (row, query) => filterString((row.categoria ? row.categoria.numero + ' - ' + row.categoria.nome : ' - '), query)
const filterByEmail = (row, query) => row.email.toLowerCase().includes(query.toLowerCase())
const filterByStatus = (row, query) => {
  return row.statusText.toLowerCase().includes(query.toLowerCase())
}

export {
  filterByBank,
  filterByAgency,
  filterByAccount,
  filterByAccessProfileName,
  filterBySituation,
  filterByCategory,
  filterByEmail,
  filterByStatus
}



// WEBPACK FOOTER //
// ./client/utils/customFilters.js